import React, { useEffect, useState } from 'react';
import './LeaderboardConfetti.css';
import cheersAudio from '../audio/cheers.mp3';

const LeaderboardConfetti = ({ soundEnabled = true }) => {
  const [particles, setParticles] = useState([]);

  useEffect(() => {
    // Play actual cheers audio file
    const playCheerSound = () => {
      try {
        const audio = new Audio(cheersAudio);
        audio.volume = 0.8; // Set volume to 80% for loud cheer
        audio.play().catch(error => {
          console.log('Audio playback failed:', error);
        });
      } catch (error) {
        console.log('Audio playback not supported');
      }
    };

    // Enhanced confetti with more particles and variety
    const colors = [
      '#ff6b6b', '#4ecdc4', '#45b7d1', '#f9ca24', '#f0932b', 
      '#e74c3c', '#9b59b6', '#3498db', '#2ecc71', '#f39c12',
      '#e67e22', '#1abc9c', '#34495e', '#e91e63', '#9c27b0'
    ];
    const shapes = ['circle', 'square', 'triangle'];
    const newParticles = [];
    
    // Create more confetti particles from bottom corners and center
    for (let i = 0; i < 150; i++) {
      const fromLeft = i % 3 === 0; // More variety in starting positions
      const fromCenter = i % 3 === 1;
      
      let startX, startY;
      if (fromCenter) {
        startX = `${45 + Math.random() * 10}%`;
        startY = '100%';
      } else {
        startX = fromLeft ? '0%' : '100%';
        startY = `${80 + Math.random() * 20}%`;
      }
      
      newParticles.push({
        id: i,
        startX: startX,
        startY: startY,
        endX: `${20 + Math.random() * 60}%`, // Wider spread
        endY: `${5 + Math.random() * 40}%`,   // Higher reach
        color: colors[Math.floor(Math.random() * colors.length)],
        size: Math.random() * 12 + 4,
        speed: 1.5 + Math.random() * 2.5,
        delay: Math.random() * 1.5,
        angle: Math.random() * 360,
        spin: Math.random() * 1080 - 540,
        shape: shapes[Math.floor(Math.random() * shapes.length)],
      });
    }
    
    setParticles(newParticles);
    
    // Play sound immediately (can be disabled by parent)
    if (soundEnabled) playCheerSound();
    
    // Clean up after animation
    const timer = setTimeout(() => {
      setParticles([]);
    }, 5000);
    
    return () => clearTimeout(timer);
  }, [soundEnabled]);

  return (
    <div className="leaderboard-confetti-container">
      {particles.map(particle => (
        <div
          key={particle.id}
          className={`leaderboard-confetti-particle leaderboard-confetti-particle--${particle.shape}`}
          style={{
            '--start-x': particle.startX,
            '--start-y': particle.startY,
            '--end-x': particle.endX,
            '--end-y': particle.endY,
            '--color': particle.color,
            '--size': `${particle.size}px`,
            '--speed': `${particle.speed}s`,
            '--delay': `${particle.delay}s`,
            '--angle': `${particle.angle}deg`,
            '--spin': `${particle.spin}deg`,
          }}
        />
      ))}
    </div>
  );
};

export default LeaderboardConfetti;
